// extracted by mini-css-extract-plugin
module.exports = {"navDropdownWrapper":"yl","navDropdownSide":"ym","navDropdownLink":"yn"};